import $api from "../http";
import {
  application_secret,
  joinPosterConfirmUrl,
  joinposterId,
} from "../../config/config";
import { posterUrl } from "../../config/config";

export default class JoinPosterService {

  static async getShops(merchantId) {
    return $api.get(
      `${posterUrl}/app/${merchantId}/shops`,
    );
  }

  static async getCategories({ merchantId, shopRefId }) {
    return $api.get(
      `${posterUrl}/app/${merchantId}/shops/${shopRefId}/categories`,
    );
  }

  static async changeCategoryVisibility({ merchantId, shopRefId, categoryRefId, visibility }) {
    return $api.put(
      `${posterUrl}/app/${merchantId}/shops/${shopRefId}/categories/${categoryRefId}/visibility/${visibility}`,
    );
  }
  static async changeProductVisibility({ merchantId, shopRefId, categoryRefId, productId, visibility }) {
    return $api.put(
      `${posterUrl}/app/${merchantId}/shops/${shopRefId}/categories/${categoryRefId}/products/${productId}/visibility/${visibility}`,
  );
  }

  static async getProductsByShop({ merchantId, shopRefId }) {
    return $api.get(
      `${posterUrl}/app/${merchantId}/shops/${shopRefId}/products`,
    );
  }

  static async getProductsByCategory({ merchantId, shopRefId, categoryRefId }) {
    return $api.get(
      `${posterUrl}/app/${merchantId}/shops/${shopRefId}/categories/${categoryRefId}/products`,
    );
  }


  static async authByJoinPosterToken(account, code) {
    const data = {
      redirect_uri: joinPosterConfirmUrl,
      code: code,
    };
    return $api.post(
      `${posterUrl}/application/${account}/register-merchant`,
      data,
    );
  }

  static async synchronizeMerchant(token, account) {
    return $api.post(
      `${posterUrl}/application/init/syncronize?account=${account}&token=${token}`,
    );
  }

  static async getMerchantData(code) {
    return $api.post(`${posterUrl}/application/auth/cpanel`, {
      code,
    });
  }

  static async updateStore(data) {
    return $api.put(`${posterUrl}/spots/`, { ...data });
  }

  static async updateStorePhoto(f, spot_id, newName) {
    const newF = new File([f], newName, { type: f.type });
    const file = new FormData();
    file.append("file", newF);
    return $api.post(
      `${posterUrl}/application/posterspotimage/${spot_id}`,
      file,
    );
  }

  static async updateMerchant(data) {
    return $api.put(`${posterUrl}/application/posterupdatemerchant/`, {
      ...data,
    });
  }

  static async updateMerchantLogo(f, merchantId, newName) {
    const newF = new File([f], newName, { type: f.type });
    const file = new FormData();
    file.append("file", newF);

    return $api.post(
      `${posterUrl}/application/postermerchantlogo/${merchantId}`,
      file,
    );
  }
}
